import axios from 'axios';
import {getCurrentUserId, isPlayer} from './currentUser';
import {lingua} from '../preferenze';
import {saldoBonus} from '../services/casinoApi';

/**
 * LE CIFRE DEL CONTO per chi le mostra in testata (lo stile Nova).
 *
 * Stessa chiamata della striscia in alto (BarraAlta): GET
 * /private/credit/{userId}/figures sul gateway. Una cifra che il servizio non
 * manda non diventa zero: sparisce. Se la chiamata non riesce non si porta
 * dietro la pagina: restano le cifre di prima, o nessuna.
 */
export function leggiCifreConto() {
  const env = window.env || {};
  const base = env.REACT_APP_API_URL;
  const token = window.localStorage.getItem('access_token');
  const id = getCurrentUserId();
  if (!base || !token || !id) return Promise.resolve(null);
  return axios
      .get(`${base}/private/credit/${id}/figures`, {
        headers: {Authorization: `Bearer ${token}`, 'Content-Type': 'application/json'},
      })
      .then((res) => res.data || null)
      .catch((e) => {
        console.warn('Saldo non disponibile:', e && e.message);
        return null;
      })
      .then(conBonus);
}

/**
 * LE CIFRE DEL CONTO COL SALDO BONUS ACCANTO, per chi gioca.
 *
 * Il saldo bonus arriva da casino-service (casinoApi.saldoBonus) nella
 * valuta del conto e si aggiunge alle cifre come «bonusBalance», con i bonus
 * ancora da sbloccare in «bonusAttivi». Non entra in userBalance: non si
 * preleva e non e' del credit-service. Se e' zero, o non arriva, la cifra
 * non c'e' e niente lo mostra.
 */
export function conBonus(dati) {
  if (!dati || !isPlayer()) return Promise.resolve(dati);
  return saldoBonus(dati.currency).then((b) => {
    if (!b || !(b.saldo > 0)) return dati;
    return {...dati, bonusBalance: b.saldo, bonusAttivi: b.attivi};
  });
}

/** Quanto manca da giocare per sbloccare i bonus attivi, sommato: 0 se nessuno. */
export function mancaDaGiocare(dati) {
  const attivi = (dati && Array.isArray(dati.bonusAttivi)) ? dati.bonusAttivi : [];
  return attivi.reduce((tot, b) => tot + Math.max(0, b.requisito - b.giocato), 0);
}

/**
 * Quanto del requisito di sblocco si è già giocato, sommando i bonus attivi:
 * {giocato, requisito, percentuale (0-100)}, o null se non c'è niente da giocare.
 * Un bonus già giocato oltre il requisito conta il requisito, non di più.
 */
export function avanzamentoBonus(dati) {
  const attivi = (dati && Array.isArray(dati.bonusAttivi)) ? dati.bonusAttivi : [];
  const requisito = attivi.reduce((tot, b) => tot + Math.max(0, b.requisito), 0);
  if (!(requisito > 0)) return null;
  const giocato = attivi.reduce((tot, b) => tot + Math.min(Math.max(0, b.giocato), Math.max(0, b.requisito)), 0);
  return {giocato, requisito, percentuale: Math.min(100, Math.round((giocato / requisito) * 100))};
}

/** Una cifra del conto come numero, o null se manca o non e' un numero. */
export function cifra(dati, chiave) {
  if (!dati) return null;
  const v = dati[chiave];
  if (v === undefined || v === null || v === '') return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
}

/** L'importo scritto per chi guarda (1.234,56 in italiano, 1,234.56 in inglese), col simbolo se la valuta e' nota. */
export function importo(n, valuta) {
  const noti = {EUR: '€', USD: '$', GBP: '£'};
  const simbolo = valuta ? (noti[String(valuta).toUpperCase()] || String(valuta).toUpperCase()) : '';
  const testo = Number(n || 0).toLocaleString(lingua(), {minimumFractionDigits: 2, maximumFractionDigits: 2});
  return simbolo ? `${testo} ${simbolo}` : testo;
}
